<template>
  <div id="app">
    <header-page></header-page>
    <section v-if="!$route.path.includes('mobile')">
      <!-- <header-page></header-page> -->
      <div class="main_content">
        <div class="navigation">
          <common-location :location-data="locationData" />
        </div>
        <div class="container">
          <component :is="getMenu"></component>
          <Transition name="fade">
            <router-view v-if="showModal"></router-view>
          </Transition>
        </div>
      </div>
      <!-- <footer-page class="footer_content"></footer-page> -->
    </section>
    <section v-else>
      <!-- <header style="display: block">
        <van-nav-bar fixed placeholder z-index="2">
          <template #left>
            <img src="@/assets/images/insurance/logo.png" height="24" />
          </template>
          <template #right>
            <img src="@/assets/images/insurance/menu.png" alt="" height="14" />
          </template>
        </van-nav-bar>
      </header> -->
      <component :is="getMenu"></component>
      <main>
        <router-view></router-view>
      </main>
    </section>
    <!-- <footer-page class="footer_content"></footer-page> -->
  </div>
</template>

<script>
import CommonLocation from '@/components/CommonLocation'
import CustomerService from '@/layout/customerService'
import InvestAndFinancing from '@/layout/investAndFinancing'
import TreasureTrove from '@/layout/treasureTrove'
import PersonalDeposit from '@/layout/personalDeposit'
import InterestRate from '@/layout/interestRate'
import ProductManual from '@/layout/productManual'
import HeaderPage from './components/HeaderPage.vue'
import FooterPage from './components/FooterPage.vue'

export default {
  name: 'App',
  components: {
    CommonLocation,
    CustomerService,
    InvestAndFinancing,
    PersonalDeposit,
    TreasureTrove,
    InterestRate,
    ProductManual,
    HeaderPage,
    FooterPage,
  },
  data() {
    return {
      showModal: false,
      myHeight: 0,
      myMarginTop: 0,
      myHeight2: 0,
    }
  },

  computed: {
    getMenu() {
      const category = (this.$route.meta && this.$route.meta.category) || ''
      let componentName = ''
      switch (category) {
        // case 'investAndFinancing':
        //   componentName = 'InvestAndFinancing'
        //   break
        // case 'customerService':
        //   componentName = 'CustomerService'
        //   break
        // case 'personalDeposit':
        //   componentName = 'PersonalDeposit'
        //   break
        // case 'treasureTrove':
        //   componentName = 'TreasureTrove'
        //   break
        case 'interestRate':
          if (this.$route.query.v && this.$route.query.v === '2') {
            componentName = 'InterestRate'
          } else {
            componentName = 'InterestRate'
          }
          break
        // case 'productManual':
        //   componentName = 'ProductManual'
        //   break
        default:
          break
      }
      // document.title =
      //   (this.$route.meta && `广东华兴银行_${this.$route.meta.title}`) || ''
      return componentName
    },
    locationData() {
      return this.$route.meta.location
    },
  },

  watch: {
    $route: {
      handler() {
        this.showModal = false
        setTimeout(() => {
          this.showModal = true
        }, 500)
      },
    },
    deep: true,
    immediate: true,
  },
  mounted() {
    function checkViewport() {
      const isMibile = window.matchMedia('(max-width:768px)').matches
      if (!isMibile) {
        // 跳转到移动端项目
        let currentUrl = window.location.href
        if (currentUrl.includes('/bank-product-mobile/#/mobile/')) {
          window.location.href = currentUrl.replace(
            '/bank-product-mobile/#/mobile/',
            '/bank-product/#/'
          )
        }
      }
    }
    checkViewport()
    window.addEventListener('resize', checkViewport)
  },
  methods: {},
}
</script>

<style lang="scss">
@import '@/assets/style/reset.scss';
@import '@/assets/style/global.scss';
@import '@/assets/style/element.scss';
@import '@/assets/style/vant.scss';
#app {
  height: 100%;
  width: 100%;
  .main_content {
    margin-top: 170px;
    margin-bottom: 40px;
  }

  .container {
    width: 1400px;
    min-width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 15px;
  }
  .navigation {
    width: 1400px;
    min-width: 1200px;
    margin: 0 auto;
  }
  .pageContainer {
    flex: 1;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
